import React from "react";
import "./preview-card.styles.scss";

const PreviewCard = ({ adDetails, handleClick }) => {
  const { imageFile, name } = adDetails;
  const imgSrc = require(`../../resources/images/${imageFile}`);
  return (
    <div className="preview" onClick={() => handleClick(adDetails)}>
      <div
        className="preview-image"
        style={{ backgroundImage: "url(" + imgSrc + ")" }}
      ></div>
      <span className="preview-name">{name}</span>
    </div>
  );
};

export default PreviewCard;
